import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { Route, Routes } from "react-router-dom"
import { AutomationsContext } from "./context"
import { AutomationsListing } from "./containers/listing"
import { ERoutes } from "../../utils/url"

export default function Automations({}): any {
    return (
        <ContentSectionContainer className="suppressionListContainer">
            <AutomationsContext.Provider value={{}}>
                <Routes>
                    <Route index path={fetchRoute({ route: ERoutes.automations })} element={<AutomationsListing />} />
                    <Route index path={"/"} element={<AutomationsListing />} />
                </Routes>
            </AutomationsContext.Provider>
        </ContentSectionContainer>
    )
}